'use strict';

module.exports = function ($stateProvider) {
    $stateProvider
    // L7 APP
        // BY LAYER 7 APP
        .state('pages.main.app_by_l7', {
            url: '/app_by_l7',
            template: require('../views/applications/app_by_l7.html'),
            controller: 'appByl7Controller',
            controllerAs: 'page',
            data: {
                title: 'Layer 7 Applications',
                daterange: true
            }
        })
            // BY LAYER 7 APP RESPONDER
            .state('pages.main.app_by_l7_resp', {
                url: '/app_by_l7_resp',
                template: require('../views/applications/app_by_l7_resp.html'),
                controller: 'appByl7RespController',
                controllerAs: 'page',
                data: {
                    title: 'Layer 7 Applications By Responder',
                    daterange: true
                }
            })
            // BY LAYER 7 APP RESPONDER ORIGIN
                .state('pages.main.app_by_l7_resp_orig', {
                    url: '/app_by_l7_resp_orig',
                    template: require('../views/applications/app_by_l7_resp_orig.html'),
                    controller: 'appByl7RespOrigController',
                    controllerAs: 'page',
                    data: {
                        title: 'Layer 7 Applications By Responder to Origin',
                        daterange: true
                    }
                })
    // DNS
        // DNS BY QUERY TYPE
        .state('pages.main.dns_by_type', {
            url: '/dns_by_type',
            template: require('../views/applications/dns_by_type.html'),
            controller: 'dnsByTypeController',
            controllerAs: 'page',
            data: {
                title: 'DNS by Query Type',
                daterange: true
            }
        })
            // DNS BY QUERY TYPE RESP
            .state('pages.main.dns_by_type_resp', {
                url: '/dns_by_type_resp',
                template: require('../views/applications/dns_by_type_resp.html'),
                controller: 'dnsByTypeRespController',
                controllerAs: 'page',
                data: {
                    title: 'Responder DNS by Query Type',
                    subtitleElm: {
                        'Query Type': 'qtype_name'
                    },
                    daterange: true
                }
            })
                // DNS BY QUERY TYPE RESP & ORIG
                .state('pages.main.dns_by_type_resp_orig', {
                    url: '/dns_by_type_resp_orig',
                    template: require('../views/applications/dns_by_type_resp_orig.html'),
                    controller: 'dnsByTypeRespOrigController',
                    controllerAs: 'page',
                    data: {
                        title: 'Responder / Origin DNS by Query Type',
                        subtitleElm: {
                            'Query Type': 'qtype_name'
                        },
                        daterange: true
                    }
                })
        // DNS BY RESOLVER
        .state('pages.main.dns_by_resolver', {
            url: '/dns_by_resolver',
            template: require('../views/applications/dns_by_resolver.html'),
            controller: 'dnsByResolverController',
            controllerAs: 'page',
            data: {
                title: 'DNS by Resolver',
                daterange: true
            }
        })
            // DNS BY RESOLVER TYPE
            .state('pages.main.dns_by_resolver_type', {
                url: '/dns_by_resolver_type',
                template: require('../views/applications/dns_by_resolver_type.html'),
                controller: 'dnsByResolverTypeController',
                controllerAs: 'page',
                data: {
                    title: 'DNS by Resolver & Query Type',
                    daterange: true
                }
            })
    // HTTP
        // HTTP BY DOMAIN
        .state('pages.main.http_by_domain', {
            url: '/http_by_domain',
            template: require('../views/applications/http_by_domain.html'),
            controller: 'httpByDomainController',
            controllerAs: 'page',
            data: {
                title: 'HTTP By Domain',
                daterange: true
            }
        })
            // HTTP BY SUBDOMAIN
            .state('pages.main.http_by_domain_sub', {
                url: '/http_by_domain_sub',
                template: require('../views/applications/http_by_domain_sub.html'),
                controller: 'httpByDomainSubController',
                controllerAs: 'page',
                data: {
                    title: 'HTTP By Subdomain',
                    daterange: true
                }
            })
                // HTTP BY URI
                .state('pages.main.http_by_domain_uri', {
                    url: '/http_by_domain_uri',
                    template: require('../views/applications/http_by_domain_uri.html'),
                    controller: 'httpByDomainUriController',
                    controllerAs: 'page',
                    data: {
                        title: 'HTTP By URI',
                        daterange: true
                    }
                })
    // SSL
        // SSL BY SERVER
        .state('pages.main.ssl_by_server', {
            url: '/ssl_by_server',
            template: require('../views/applications/ssl_by_server.html'),
            controller: 'sslByServerController',
            controllerAs: 'page',
            data: {
                title: 'SSL Top Level Server Name',
                daterange: true
            }
        })
            // SSL BY SERVER
            .state('pages.main.ssl_by_server_name', {
                url: '/ssl_by_server_name',
                template: require('../views/applications/ssl_by_server_name.html'),
                controller: 'sslByServerNameController',
                controllerAs: 'page',
                data: {
                    title: 'SSL Server Name',
                    daterange: true
                }
            })
                // SSL BY SERVER
                .state('pages.main.ssl_by_server_name_orig', {
                    url: '/ssl_by_server_name_orig',
                    template: require('../views/applications/ssl_by_server_name_orig.html'),
                    controller: 'sslByServerNameOrigController',
                    controllerAs: 'page',
                    data: {
                        title: 'SSL Server Name by Origin',
                        daterange: true
                    }
                })
    // FTP
        // RESPONDER FTP
        .state('pages.main.ftp_resp`', {
            url: '/ftp_resp',
            template: require('../views/applications/ftp_resp.html'),
            controller: 'ftpRespController',
            controllerAs: 'page',
            data: {
                title: 'FTP By Responder',
                daterange: true
            }
        })
            // RESPONDER ORIGIN FTP
            .state('pages.main.ftp_resp_orig', {
                url: '/ftp_resp_orig',
                template: require('../views/applications/ftp_resp_orig.html'),
                controller: 'ftpRespOrigController',
                controllerAs: 'page',
                data: {
                    title: 'FTP By Responder to Origin',
                    daterange: true
                }
            })
    // SSH
        // SSH STATUS
        .state('pages.main.ssh_status', {
            url: '/ssh_status',
            template: require('../views/applications/ssh_status.html'),
            controller: 'sshStatusController',
            controllerAs: 'page',
            data: {
                title: 'SSH Status',
                daterange: true
            }
        })
            // SSH STATUS RESP
            .state('pages.main.ssh_status_resp', {
                url: '/ssh_status_resp',
                template: require('../views/applications/ssh_status_resp.html'),
                controller: 'sshStatusRespController',
                controllerAs: 'page',
                data: {
                    title: 'Responder SSH Status',
                    daterange: true
                }
            })
                // SSH STATUS RESP ORIG
                .state('pages.main.ssh_status_resp_orig', {
                    url: '/ssh_status_resp_orig',
                    template: require('../views/applications/ssh_status_resp_orig.html'),
                    controller: 'sshStatusRespOrigController',
                    controllerAs: 'page',
                    data: {
                        title: 'Responder / Origin SSH Status',
                        daterange: true
                    }
                })
}




/** WEBPACK FOOTER **
 ** ./src/pages/routes/applications.js
 **/